import {
    FETCH_USER_SUBSCRIPTIONS_REQUEST,
    FETCH_USER_SUBSCRIPTIONS_SUCCESS,
    FETCH_USER_SUBSCRIPTIONS_FAILURE
  } from './types';
  import { getUserAllSubscriptions } from '../../services/user.services'; 
  
  export const fetchUserSubscriptions = (userId, sessionData) => async dispatch => {
    dispatch({ type: FETCH_USER_SUBSCRIPTIONS_REQUEST });
    try {
      const response = await getUserAllSubscriptions({ userId }, sessionData);
      dispatch({
        type: FETCH_USER_SUBSCRIPTIONS_SUCCESS,
        payload: response.data
      });
    } catch (error) {
      dispatch({
        type: FETCH_USER_SUBSCRIPTIONS_FAILURE,
        payload: error.message
      });
    }
  };
  